const breadCrumb = "Lotação de Servidores - Tabelas Básicas";

const routes = [
  {
    path: "/manutencao-da-area-curso",
    name: "manutencao-da-area-curso",
    meta: {
      allowedPermissions: ["area_curso_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ManutencaoDeAreaCursos/ManutencaoAreaCursoHome.vue"),
  },
  {
    path: "/manutencao-da-area-curso/novo",
    name: "manutencao-da-area-curso-novo",
    meta: {
      allowedPermissions: ["area_curso_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ManutencaoDeAreaCursos/ManutencaoAreaCursoCad.vue"),
  },
  {
    path: "/manutencao-da-area-curso/editar/:id",
    name: "manutencao-da-area-curso-editar",
    meta: {
      allowedPermissions: ["area_curso_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ManutencaoDeAreaCursos/ManutencaoAreaCursoEdit.vue"),
  },
];

export default routes;
